export default __webpack_public_path__ + "543feba2ab1f9ee141cd3903178bea50.woff";